import { render } from "./slidenote-13.vue?vue&type=template&id=3add8413"
import script from "./slidenote-13.vue?vue&type=script&lang=js"
export * from "./slidenote-13.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__